const sp = new URLSearchParams(document.location.search);
export const useCookieBasedAuth = sp.get('authmode') !== 'k' && !sp.has('code');
